"use client";

import React, { useContext } from "react";
import { useConnection } from "wagmi";
import { WalletRestoringContext } from "~/src/context/WalletRestoringContext";
import { AppLoadingScreen } from "~/src/components/AppLoadingScreen";
import { Navigate, useLocation } from "react-router-dom";
import { COOKIE_KEY } from "../../constants/cookie";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute - Redirects to login if user is not authenticated
 * Waits for wallet restoration, then requires a live wallet connection.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isConnected, status } = useConnection();
  const isRestoringWallet = useContext(WalletRestoringContext);

  // Get connectedWallet from cookies
  const getCookie = (name: string): string | null => {
    if (typeof document === "undefined") {
      return null;
    }
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find((row) => row.startsWith(`${name}=`));
    return cookie ? cookie.split("=")[1] : null;
  };

  const connectedWallet = getCookie(COOKIE_KEY.connectedWallet);

  if (
    connectedWallet &&
    (isRestoringWallet || status === "connecting" || status === "reconnecting")
  ) {
    return <AppLoadingScreen />;
  }

  if (!connectedWallet || !isConnected) {
    // Redirect to login with return path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
